/**
 * @generated SignedSource<<8989156b32b3b2e17f297f8d12f2b0ec>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SharedRecentSales_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"SharedRelatedItemsSection_user">;
  readonly " $fragmentType": "SharedRecentSales_user";
};
export type SharedRecentSales_user$key = {
  readonly " $data"?: SharedRecentSales_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"SharedRecentSales_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SharedRecentSales_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SharedRelatedItemsSection_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "240000b57cc2aa76e7ab9eb8bc62195f";

export default node;
